import React, { createContext, useState, useContext, useCallback } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState({
        first_name: '',
        last_name: '',
        position: '',
        department: '',
        employee_id: '',
        office: '',
        user_id: '',
        avatar_photo: null,
        is_head_of_department: false,
        supervised_department: null
    });

    const updateUserInfo = useCallback((newUserInfo) => {
        setUserInfo(newUserInfo);
    }, []);

    return (
        <UserContext.Provider value={{ userInfo, updateUserInfo }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserInfo = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUserInfo must be used within a UserProvider');
    }
    return context;
}; 